import { enMessages } from "@/i18n/en";
import { esMessages } from "@/i18n/es";
import type { LocaleCode, Messages } from "@/i18n/types";

export const MESSAGES: Record<LocaleCode, Messages> = {
  en: enMessages,
  es: esMessages,
};
